import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Generate a cryptographically secure random user secret
function generateUserSecret(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
}

interface UserState {
  userId: string | null;
  userName: string | null;
  userSecret: string;
  isRegistered: boolean;
  timeOffset: number;

  setUserId: (id: string) => void;
  setUserName: (name: string) => void;
  setRegistered: (registered: boolean) => void;
  setTimeOffset: (offset: number) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      userId: null,
      userName: null,
      userSecret: generateUserSecret(), // Generate on first load
      isRegistered: false,
      timeOffset: 0,

      setUserId: (id) => set({ userId: id }),
      setUserName: (name) => set({ userName: name }),
      setRegistered: (registered) => set({ isRegistered: registered }),
      setTimeOffset: (offset) => set({ timeOffset: offset }),
      clearUser: () => set({ userId: null, userName: null, isRegistered: false, timeOffset: 0 }),
    }),
    {
      name: 'yt-music-sync-user',
    }
  )
);
